export default {
      id: "reviews-usage",
      viewBox: "0 0 35 29",
      url: __webpack_public_path__ + "app/svg/sprite.svg#reviews",
      toString: function () {
        return this.url;
      }
    }